import { MedicineOrderItem } from "./medicine";
import {Individual} from "./individual";
import { Address, AddressCreatePayload, AddressEditPayload } from "./address";
import type { CompanyInvoiceMode, WeeklyInvoiceDay } from "src/constants/distributor-invoicing";

export interface CompanyType {
    id: number;
    type: string;
    code: string;
    created_at: string;
    updated_at: string | null;
    deleted_at: string | null;
}

/** Backend GET /company is_active query (defaults to active when omitted). */
export type CompanyActiveFilter = 'active' | 'inactive' | 'both';

export const COMPANY_ACTIVE_FILTER_OPTIONS: { value: CompanyActiveFilter; label: string }[] = [
    { value: 'active', label: 'Active companies' },
    { value: 'inactive', label: 'Inactive companies' },
    { value: 'both', label: 'All companies' },
];

export interface CreateCompanyPayload {
    name: string;
    email: string;
    email_alt: string;
    phone_number: string;
    phone_number_alt:  string;
    practice_number: string;
    vat_registration_number: string;
    company_type_id: number | undefined;
    primary_contact_id: number | null | undefined;
    address: AddressCreatePayload | undefined;
    distributor_id: number | undefined;
    /** Distributor (DIS) invoicing — backend may ignore when not applicable. */
    invoice_mode?: CompanyInvoiceMode | null;
    weekly_invoice_day?: WeeklyInvoiceDay | null;
    is_active?: boolean | number | null;
}

export interface EditCompanyPayload {
    id: number | undefined;
    name: string;
    email: string;
    email_alt: string;
    phone_number: string;
    phone_number_alt:  string;
    practice_number: string;
    vat_registration_number: string;
    company_type_id: number | undefined;
    primary_contact_id: number | null | undefined;
    address: AddressEditPayload | undefined;
    distributor_id: number | undefined;
    invoice_mode?: CompanyInvoiceMode | null;
    weekly_invoice_day?: WeeklyInvoiceDay | null;
    is_active?: boolean | number | null;
}

export interface Company {
    id: number | undefined;
    name: string;
    email: string;
    email_alt: string;
    phone_number: string;
    phone_number_alt: string;
    practice_number: string;
    vat_registration_number: string;
    address_id: number | undefined;
    company_type_id: number | undefined;
    primary_contact_id: number | undefined;
    created_at: string | undefined;
    updated_at: string | undefined;
    deleted_at: string | undefined;
    addresses: Address[];
    distributor_id: number | null;
    distributor: Company | null;
    /** Sage contact id once company has been added to Sage (POST /sage/contacts). */
    sage_contact_id?: string | null;
    /** Distributor (DIS) — grouped invoicing mode. */
    invoice_mode?: CompanyInvoiceMode | string | null;
    weekly_invoice_day?: WeeklyInvoiceDay | string | null;
    /** Active flag when supported by API (distributor / company). */
    is_active?: boolean | number | null;
}

export interface CompanyFormDataInterface {
    title: string;
    initials: string;
    first_name: string;
    last_name: string;
    gender: string;
    date_of_birth: string;
    dependant_number: number;
    phone_number: string;
    phone_number_alt: string;
    building_apt_number: number;
    email: string;
    email_alt: string;
    address_1: string;
    address_2: string;
    province: string;
    postcode: string;
    country: string;
    company_id: number | undefined;
    individual_type_id: number;
    delivery_type_id: number;
    company: Company;
    medicine: MedicineOrderItem[] | undefined;
}

export interface companyDetails {
    id: number | undefined;
    name: string;
}